import BaseModel from '../base/BaseModel.model';
export default class ContentType extends BaseModel {

   public contentTypeId?: number;
   public name?: string;
   public description?: string;

    init(){
       this.contentTypeId = 0;
       this.name = "";
       this.description = "";
    }

}